import { jsx as _jsx } from "react/jsx-runtime";
export const TabItem = ({ children, className }) => _jsx("div", { className: className, children: children });
TabItem.displayName = 'Tabs.Item';
